import { environment } from './../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CombosService {
  BASEURL: string;
  httpHeaders: HttpHeaders;

  constructor(private http: HttpClient) {
    this.BASEURL = environment.apiUrl;

    this.httpHeaders = new HttpHeaders({
      Authorization: localStorage.getItem('tokenMappe'),
    });
  }

  listaGrupos(id: string): Observable<any> {
    return this.http.get(`${this.BASEURL}/optionals/brand/groups/${id}`, {
      headers: this.httpHeaders,
    });
  }

  listaComboProduto(id: string): Observable<any> {
    return this.http.get(`${this.BASEURL}/combos/items/${id}`, {
      headers: this.httpHeaders,
    });
  }

  listaItemCombo(id: string): Observable<any> {
    return this.http.get(`${this.BASEURL}/combos/${id}`, {
      headers: this.httpHeaders,
    });
  }

  salvaCombo(body: any): Observable<any> {
    return this.http.post(`${this.BASEURL}/combos`, body, {
      headers: this.httpHeaders,
    });
  }

  editarItemCombo(id: string, body: any): Observable<any> {
    return this.http.put(`${this.BASEURL}/combos/${id}`, body, {
      headers: this.httpHeaders,
    });
  }

  excluirItemCombo(id: string): Observable<any> {
    return this.http.delete(`${this.BASEURL}/combos/${id}`, {
      headers: this.httpHeaders,
    });
  }
}
